import { render, staticRenderFns } from "./bulk-upload-service-coterm-modal.vue?vue&type=template&id=542ce724&scoped=true&"
import script from "./bulk-upload-service-coterm-modal.vue?vue&type=script&lang=tsx&"
export * from "./bulk-upload-service-coterm-modal.vue?vue&type=script&lang=tsx&"
import style0 from "./bulk-upload-service-coterm-modal.vue?vue&type=style&index=0&id=542ce724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542ce724",
  null
  
)

export default component.exports